import React from 'react';
import PropTypes from 'prop-types';
import './Bevel.css';

const Bevel = ({ children, inverse }) => {
    return (
        <div className={inverse ? 'Bevel_inverse' : 'Bevel'}>
            <div className="Bevel-outer">
                <div className="Bevel-inner">
                    {children}
                </div>
            </div>
        </div>
    );

};

Bevel.propTypes = {
    children: PropTypes.any,
    inverse: PropTypes.bool
};

export default Bevel;



// WEBPACK FOOTER //
// ./src/components/Browser/Bevel.jsx